import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { format } from "date-fns";
import { deAT } from "date-fns/locale";
import { Input } from "@/components/ui/input";
import CustomLabel from "./CustomLabel";
import { cn } from "@/lib/utils";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Button } from "@/components/ui/button";
type Props = {
  form: any;
  name: string;
  label: string;
  placeholder: string;
  bgError?: string;
  textError?: string;
  type?: any;
  pattern?: string;
  inputmode?:
    | "search"
    | "text"
    | "email"
    | "tel"
    | "url"
    | "none"
    | "numeric"
    | "decimal";
};

const CustomDatePicker = ({
  form,
  name,
  placeholder,
  label,
  bgError,
  textError,
  type,
  pattern,
  inputmode,
}: Props) => {
  return (
    <div className="grid w-full items-center gap-1.5">
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem className="flex flex-col">
            <CustomLabel id={name} label={label} />
            <FormControl>
              <Popover>
                <PopoverTrigger asChild>
                  <FormControl>
                    <Button
                      variant={"outline"}
                      className={cn(
                        "h-[50px] w-full px-4 py-3 text-left font-normal",
                        !field.value && "text-muted-foreground"
                      )}
                    >
                      {field.value ? (
                        format(field.value, "PPP", {
                          locale: deAT,
                        })
                      ) : (
                        <span className="text-base">{placeholder}</span>
                      )}
                      <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                  </FormControl>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                  <Calendar
                    mode="single"
                    selected={field.value}
                    onSelect={field.onChange}
                    disabled={(date) => date < new Date()}
                    initialFocus
                  />
                </PopoverContent>
              </Popover>
            </FormControl>
            <FormMessage className={`${textError ? textError : "text-red"}`} />
          </FormItem>
        )}
      />
    </div>
  );
};

export default CustomDatePicker;
